import 'css-chunksrc/client/scenes/wbs/task/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_ap0vk_1",
  "details": "_details_ap0vk_5",
  "detailsWrapper": "_detailsWrapper_ap0vk_11",
  "debug": "_debug_ap0vk_18",
  "list": "_list_ap0vk_22",
  "main": "_main_ap0vk_29",
  "allocation": "_allocation_ap0vk_1",
  "infoBubble": "_infoBubble_ap0vk_43",
  "slideIn": "_slideIn_ap0vk_1",
  "picture": "_picture_ap0vk_49",
  "summary": "_summary_ap0vk_55",
  "menu": "_menu_ap0vk_64",
  "addAllocationIcon": "_addAllocationIcon_ap0vk_68",
  "resourcesList": "_resourcesList_ap0vk_74",
  "up": "_up_ap0vk_81",
  "down": "_down_ap0vk_86",
  "quickAllocationMenu": "_quickAllocationMenu_ap0vk_92",
  "overlay": "_overlay_ap0vk_97"
};